<template>
  <div class="renewList" id="renewList">
    <div class="renewBook-list" v-for="(item, index) in list" :key="index">
      <div class="renewBook-item">
        <div class="icon">
          <span>{{index + 1 >= 10 ? index + 1 : '0' + (index + 1)  }}</span>
        </div>
        <div class="left">
          <div class="renewBook-title">家居焕新预约</div>
          <p class="renewBook-date">报名时间：{{ formatDate(item.create_time) }}</p>
        </div>
        <div class="right">
          <div v-if="type === 1" class="bottom-item" @click="deleteItem(item.id)">删除</div>
          <div class="bottom-item" @click="editItem(item)">修改</div>
        </div>
      </div>
    </div>
    <div v-if="isFinished" class="finished">没有更多</div>
    <div v-if="loading" class="finished">
      加载中
      <i class="el-icon-loading"></i>
    </div>
    <RenewBooking v-if="showRenewBooking" :show="showRenewBooking" :info="info" @close="showRenewBooking = false" @refresh="onRefresh"></RenewBooking>
  </div>
</template>

<script>
import axios from 'axios'
const md5 = require('js-md5')
import qs from 'qs'
import RenewBooking from "@/components/renewBooking.vue"

export default {
  name: 'renewList',
  components: {
    RenewBooking
  },
  props: {
    userInfo: {}
  },
  data() {
    return {
      type: 1,
      list: [],
      loading: false,
      page: {
        pageNum: 1,
        pageSize: 5,
      },
      allPage: 1,
      isFinished: false,
      showRenewBooking: false,
      isClick: false
    }
  },
  computed: { },
  watch: {},
  created() {
    this.getList()
  },
  mounted() {
    window.scrollTo(0, 0)
    window.addEventListener('scroll', this.onScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    getList() {
      console.log('getList', this.isFinished, this.loading)
      if (this.isFinished || this.loading) return
      this.loading = true
      const stamp = Date.now()
      const user_id = JSON.parse(localStorage.getItem('giftsUser')).id
      const { pageNum, pageSize } = this.page
      const key = atob(localStorage.getItem('key'))
      const token = localStorage.getItem('token')
      const sign = md5(`${stamp}${pageNum}${pageSize}${key}`)
      const data = {
        stamp,
        user_id,
        token,
        pageNum,
        pageSize,
        stamp,
        sign
      }
      axios.get('/interface/searchBooking', { params: data }).then(res => {
        if (res.data.result === 1) {
          this.list.push(...res.data.data)
          this.page.pageNum++
          if (res.data.length === 0) {
            this.isFinished = true;
          }
          if (this.list.length >= res.data.total) {
            this.isFinished = true
          }
          this.loading = false;
        } else {
          this.$message(res.data.msg)
        }
      })
    },
    onScroll() {
      const target = document.getElementById('renewList');
      const targetRect = target.getBoundingClientRect();
      const distanceFromBottom = window.innerHeight - targetRect.bottom;
      if (distanceFromBottom > 0 && !this.isFinished) {
        this.getList(); // 滚动到底部时加载数据
      }
    },
    editItem(item) {
      this.info = item
      this.showRenewBooking = true
    },
    formatDate(val) {
      if (!val) {
        return ''
      }
      var date = new Date(val)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      // var hour = date.getHours()
      // var min = date.getMinutes()
      // var second = date.getSeconds()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      // hour = hour < 10 ? '0' + hour : hour
      // min = min < 10 ? '0' + min : min
      // second = second < 10 ? '0' + second : second
      return (
        year + '-' + month + '-' + day
      )
    },
    onRefresh() {
      window.scrollTo(0, 0)
      this.page.pageNum = 1
      this.list = []
      this.isFinished = false
      this.getList()
    },
    deleteItem(id) {
      if (this.isClick) return
      this.isClick = true
      const stamp = Date.now()
      const token = localStorage.getItem('token')
      const user_id = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')).id : ''
      const key = atob(localStorage.getItem('key'))
      const sign = md5(`${stamp}${token}${user_id}${key}`)
      const data = {
        booking_id: id,
        user_id,
        token,
        stamp,
        sign
      }
      axios.post('/interface/delBooking', qs.stringify(data)).then((res) => {
        if (res.data.result === 1) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.page.pageNum = 1
          this.list = []
          this.isFinished = false
          this.getList()
        } else if (res.data.result == 1001) {
          this.$emit('refreshLogin', true)
          this.$message(res.data.msg)
        } else {
          this.$message(res.data.msg)
        }
        this.isClick = false
      }).catch(err => {
        this.isClick = false
        this.$message(err)
      }) 
    }
  }
}
</script>
<style lang='less' scoped>
.renewList {
  margin-top: 35px;
  .tab-bar {
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    .tab-radio{
      display: flex;
      padding-left: 23px;
      .radio-item {
        cursor: pointer;
        position: relative;
        margin-right: 35px;
        padding-right: 35px;
        font-size: 24px;
        font-weight: 400;
        color: #999999;
        line-height: 53px;
        &:not(:last-child)::after {
          content: '';
          right: 0;
          top: 15px;
          position: absolute;
          display: inline-block;
          width: 1px;
          height: 18px;
          background: #CCCCCC;
        }
        &.active{
          font-weight: 600;
          color: #4E8B46;
          span {
            display: inline-block;
            line-height: 53px;
            border-bottom: 4px solid #4E8B46;
          }
        }
      }
    }
    .tab-page {
      display: flex;
      align-items: center;
      .page {
        cursor: pointer;
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 12px;
        border-radius: 4px;
        border: 1px solid #B8D4B4;
        font-size: 20px;
        font-weight: 400;
        color: #999999;
        color: #4E8B46;
        &.disabled{
          cursor: not-allowed;
          color: #999;
          border: 1px solid #999999;
        }
      }
    }
  }
  .renewBook-list{
    border: 1px solid #B8D4B4;
    border-radius: 15px;
    margin-bottom: 17.5px;
    .renewBook-item{
      height: 130px;
      background: #FFFFFF;
      border-radius: 15px;
      border: 1px solid #B8D4B4;
      position: relative;
      display: flex;
      padding: 23px;
      padding-left: 91px;
      .icon {
        width: 67px;
        height: 68px;
        top: -3px;
        left: -3px;
        position: absolute;
        background: url('../../../assets/renew/bookList-icon.png')no-repeat;
        background-size: 100% 100%;
        line-height: 60px;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        text-align: center;
        span {
          margin-left: -10px;
        }
      }
      .left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        justify-content: center;
        flex: 1;
        .renewBook-title {
          font-size: 24px;
          font-weight: 400;
          color: #4E8B46;
        }
        .renewBook-date {
          font-size: 18px;
          font-weight: 400;
          color: #999999;
        }
      }
      .right{
        display: flex;
        align-items: center;
        .bottom-item {
          cursor: pointer;
          width: 160px;
          height: 50px;
          line-height: 50px;
          border: 1px solid #B8D4B4;
          font-size: 20px;
          font-weight: 400;
          color: #4E8B46;
          border-radius: 50px;
          margin-right: 24.5px;
        }
      }
    }
  }
  .finished {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #999;
  } 
}
</style>
